module.exports = __webpack_public_path__ + "static/media/home-icantbreathe.218306dc.png";